// import { useState } from "react";
import { useRef } from "react";
import styles from "./Header.module.css";

function Header({ onSetNotification }) {
  const ref = useRef(3);

  function handleClick() {
    onSetNotification(false);
    ref.current = 0;
  }

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <strong className={styles.notfications}>Notifications</strong>
        <span className={styles.numNotifications} ref={ref}>
          {ref.current}
        </span>
      </div>
      <button className={styles.btn} onClick={handleClick}>
        Mark all as read
      </button>
    </header>
  );
}

export default Header;
